var React = require('react');

function Collab (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0, 0)"},[React.createElement("path",{"d":"M11.609,16.912l2.104-3.367C14.419,13.837,15.191,14,16,14c3.309,0,6-2.691,6-6s-2.691-6-6-6s-6,2.691-6,6\n\tc0,1.782,0.785,3.38,2.022,4.479l-2.108,3.372L11.609,16.912z","key":0}),React.createElement("path",{"data-color":"color-2","d":"M6,18c-3.309,0-6,2.691-6,6s2.691,6,6,6c2.967,0,5.431-2.167,5.91-5H17v-2h-5.09\n\tC11.431,20.167,8.967,18,6,18z","key":1}),React.createElement("path",{"d":"M26,18c-0.809,0-1.581,0.163-2.286,0.455l-2.289-3.662l-1.695,1.061l2.292,3.667\n\tC20.785,20.62,20,22.218,20,24c0,3.309,2.691,6,6,6s6-2.691,6-6S29.309,18,26,18z","key":2})]));
}

Collab.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 32 32"};

module.exports = Collab;

Collab.default = Collab;
